module.exports = __webpack_public_path__ + "img/times.714a79ad.svg";